import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import Button from "@mui/material/Button";
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

import {featureInterface} from "../../../../interfaces/featureInterface";
import {setWizardActiveItem, setWizardActiveStep, setWizardSelectedValues} from "../../../../actions/wizardFunctions";
import {categoryIsInTheWizard} from "../../lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {setLookOpened} from "../../../../actions/lookFunctions";


const ShopFeatureWizardButton = (props) => {

  const {feature, setWizardSelectedValues, wizardList, setLookOpened, setWizardActiveItem, activePreset} = props;

  const hasWizard = categoryIsInTheWizard(wizardList, feature.partId, activePreset) || categoryIsInTheWizard(wizardList, feature.partId);
  // first check current preset wizard, and then all other rooms
  if (!hasWizard) {
    return null
  }

  const visualizeButtonClick = () => {
    setWizardSelectedValues({}, true);
    // setWizardActiveStep(0);
    setLookOpened(true);
    setWizardActiveItem(hasWizard);
  }

  return (
    <Button className={"look-button look-button--gray look-button--42 look-button--10-radius look-button--no-transform"}
            startIcon={<AutoFixHighIcon/>}
            onClick={visualizeButtonClick}>
      <FormattedMessage id="wizard.start.button" values={{wizardName: hasWizard.name}}/>
    </Button>
  )
};

ShopFeatureWizardButton.propTypes = {
  feature: PropTypes.shape(featureInterface).isRequired
}

const mapStateToProps = (store) => {
  const {wizardList} = store.wizardState;
  const {activePreset} = store.bathroomVisualizerState;

  return {
    wizardList,
    activePreset,
  };
};

const mapDispatchToProps = {
  setWizardSelectedValues,
  setWizardActiveStep,
  setLookOpened,
  setWizardActiveItem,
}

export default connect(mapStateToProps, mapDispatchToProps)(ShopFeatureWizardButton)
